// ----------------------- Form Persistence Constants -----------------------

export const FORM_PERSISTENCE_COOKIE_NAME = (formKey) =>
	`form-persistence-storage-${formKey}`;
export const FORM_PERSISTENCE_COOKIE_EXPIRATION = 5;
// --------------------------- Onboarding constants --------------------------- //

export const OnboardingStep = {
	NAVIGATE_TO_USERS_PAGE: 'NAVIGATE_TO_USERS_PAGE',
	CREATE_NEW_USER: 'CREATE_NEW_USER',
	NAVIGATE_TO_WORKOUT_LIBRARY: 'NAVIGATE_TO_WORKOUT_LIBRARY',
	FILL_WORKOUT_FORM: 'FILL_WORKOUT_FORM',
	CREATE_NEW_EXERCISE: 'CREATE_NEW_EXERCISE',
	CREATE_NEW_WORKOUT: 'CREATE_NEW_WORKOUT',
	NAVIGATE_TO_SCHEDULE: 'NAVIGATE_TO_SCHEDULE',
	ADD_WORKOUT_TO_SCHEDULE: 'ADD_WORKOUT_TO_SCHEDULE',
	NAVIGATE_TO_SCHEDULE_TO_TRACK_WORKOUT:
		'NAVIGATE_TO_SCHEDULE_TO_TRACK_WORKOUT',
	OPEN_WORKOUT_MODAL: 'OPEN_WORKOUT_MODAL',
	TRACK_WORKOUT_FOR_ATHLETE: 'TRACK_WORKOUT_FOR_ATHLETE',
	NAVIGATE_TO_SCHEDULE_WITH_COMPLETED_WORKOUT:
		'NAVIGATE_TO_SCHEDULE_WITH_COMPLETED_WORKOUT',
	OPEN_MODAL_COMPLETED_WORKOUT: 'OPEN_MODAL_COMPLETED_WORKOUT',
	VISIT_COMPLETED_WORKOUT: 'VISIT_COMPLETED_WORKOUT',
};

export const OnboardingSidebarItems = {
	USERS: 'users',
	WORKOUT_LIBRARY: 'workoutLibrary',
	SCHEDULE: 'schedule',
};

export const OnboardingSidebarValues = {
	users: OnboardingSidebarItems.USERS,
	workoutLibrary: OnboardingSidebarItems.WORKOUT_LIBRARY,
	schedule: OnboardingSidebarItems.SCHEDULE,
};

export const NavigationSteps = [
	OnboardingStep.NAVIGATE_TO_USERS_PAGE,
	OnboardingStep.NAVIGATE_TO_WORKOUT_LIBRARY,
	OnboardingStep.NAVIGATE_TO_SCHEDULE,
	OnboardingStep.NAVIGATE_TO_SCHEDULE_TO_TRACK_WORKOUT,
	OnboardingStep.NAVIGATE_TO_SCHEDULE_WITH_COMPLETED_WORKOUT,
];

export const EntitySteps = [
	OnboardingStep.CREATE_NEW_USER,
	OnboardingStep.CREATE_NEW_WORKOUT,
	OnboardingStep.ADD_WORKOUT_TO_SCHEDULE,
];

// Elements selectors - Left Side Bar

export const SIDEBAR_ITEM_SELECTOR = (usersPath) =>
	`#root > div.drawer.drawer-mobile > div.drawer-side > ul > li > a[href="${usersPath}"]`;
